import type { CoachAnchorScope } from './anchors';

/**
 * Places inside product UI where a step can show inline instead of as a
 * floating card: a dialog renders `<CoachSlot slot=... />` and the current
 * step's copy appears there when the step uses that slot.
 */
export interface CoachSlotDefinition {
  label: string;
  /** Set when the slot repeats; the app passes this id so only the journey's instance shows. */
  scope?: CoachAnchorScope;
}

export const COACH_SLOTS = {
  'studio-calendar': { label: 'Content Studio calendar' },
  'post-dialog': { label: 'Posting window', scope: 'projectNodeId' },
} as const satisfies Record<string, CoachSlotDefinition>;

export type CoachSlotId = keyof typeof COACH_SLOTS;

export const COACH_SLOT_IDS = Object.keys(COACH_SLOTS) as CoachSlotId[];
